"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPSERT_STATION_NOTE_FRAGMENT = exports.COMPLETED_OSCE_STATION_FRAGMENT = exports.COMPLETED_OSCE_MARKSHEET_FRAGMENT = exports.STATION_CONCEPT_FRAGMENT = exports.OSCE_MATCHMAKING_ACTION_FIELDS = exports.OSCE_MARKSHEET_FIELDS = exports.OSCE_MARKSHEET_MARK_FIELDS = exports.OSCE_STATION_FIELDS = exports.OSCE_STATION_MARK_FIELDS = void 0;
const client_1 = require("@apollo/client");
const picture_1 = require("./picture");
const video_1 = require("./video");
exports.OSCE_STATION_MARK_FIELDS = (0, client_1.gql) `
  fragment OsceStationMarkFields on OsceStationMark {
    id
    index
    osceStationId
    header
    name
    choices {
      id
      name
      type
      score
    }
  }
`;
exports.OSCE_STATION_FIELDS = (0, client_1.gql) `
  ${picture_1.PICTURE_FIELDS}
  ${exports.OSCE_STATION_MARK_FIELDS}
  ${video_1.VIDEO_FIELDS}
  fragment OsceStationFields on OsceStation {
    id
    updatedAt
    name
    hiddenName
    status
    userNote {
      id
      userId
      stationId
      note
      updatedAt
    }
    osceType {
      id
      name
    }
    entitlement {
      id
      name
      index
    }
    difficulty
    candidateBrief
    examinerBrief
    actorBrief
    explanation
    marks {
      ...OsceStationMarkFields
    }
    totalMarks
    completedMarks
    topics {
      id
      name
    }
    candidatePictures {
      ...PictureFields
    }
    actorPictures {
      ...PictureFields
    }
    examinerPictures {
      ...PictureFields
    }
    walkthroughPictures {
      ...PictureFields
    }
    videos {
      ...VideoFields
    }
    demo
    # user-specific keys
    # lastOsceMarksheetId
    # score
  }
`;
exports.OSCE_MARKSHEET_MARK_FIELDS = (0, client_1.gql) `
  ${exports.OSCE_STATION_MARK_FIELDS}
  fragment OsceMarksheetMarkFields on OsceMarksheetMark {
    id
    index
    mark
    selectedChoice
    osceMarksheetId
    osceStationMarkId
    osceStationMark {
      ...OsceStationMarkFields
    }
  }
`;
exports.OSCE_MARKSHEET_FIELDS = (0, client_1.gql) `
  ${exports.OSCE_MARKSHEET_MARK_FIELDS}
  fragment OsceMarksheetFields on OsceMarksheet {
    id
    createdAt
    updatedAt
    timeTaken
    osceStationId
    solo
    globalScore
    score
    feedback
    agoraId
    sessionId
    isTimed
    readingTime
    stationTime
    feedbackTime
    startedAt
    endedAt
    pausedAt
    timeRemaining
    totalStationTime
    stageTime
    stage
    marks {
      ...OsceMarksheetMarkFields
    }
    members {
      # id - do not pass otherwise all unassigned roles = candidate
      osceMarksheetId
      userId
      user {
        id
        displayName
      }
      role
    }
    users {
      id
      displayName
    }
    activeUsers {
      id
      displayName
    }
    state
    completed
  }
`;
exports.OSCE_MATCHMAKING_ACTION_FIELDS = (0, client_1.gql) `
  fragment OsceMatchmakingActionFields on OsceMatchmakingAction {
    osceMarksheetId
    sessionId
    matchedUsers
    userId
    classYear
    lastSyncAt
    startedAt
    grouped
    completed
  }
`;
exports.STATION_CONCEPT_FRAGMENT = (0, client_1.gql) `
  fragment StationStatus on OsceStation {
    status
  }
`;
exports.COMPLETED_OSCE_MARKSHEET_FRAGMENT = (0, client_1.gql) `
  fragment CompletedOsceMarksheetFragment on OsceMarksheet {
    completed
    score
    globalScore
    state
    timeTaken
    endedAt
  }
`;
exports.COMPLETED_OSCE_STATION_FRAGMENT = (0, client_1.gql) `
  fragment CompletedOsceStationFragment on OsceStation {
    score
    completedMarks
    lastOsceMarksheetId
  }
`;
// used in cache updator
exports.UPSERT_STATION_NOTE_FRAGMENT = (0, client_1.gql) `
  fragment UpsertStationNoteFragment on OsceStation {
    userNote {
      userId
      stationId
      note
      createdAt
      updatedAt
    }
  }
`;
